import { Action } from '../action.type';

export const GOOGLE_SIGN_IN = 'GOOGLE_SIGN_IN';
export const EMAIL_SIGN_IN = 'EMAIL_SIGN_IN';
export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS';
export const SIGN_IN_FAILURE = 'SIGN_IN_FAILURE';
export const EMAIL_SIGN_UP = 'EMAIL_SIGN_UP';
export const SIGN_UP_FAILURE = 'SIGN_UP_FAILURE';
export const SIGN_OUT = 'SIGN_OUT';
export const SIGN_OUT_SUCCESS = 'SIGN_OUT_SUCCESS';
export const SIGN_OUT_FAILURE = 'SIGN_OUT_FAILURE';
export const VERIFY_TOKEN = 'VERIFY_TOKEN';
export const VERIFY_TOKEN_SUCCESS = 'VERIFY_TOKEN_SUCCESS';
export const VERIFY_TOKEN_FAILURE = 'VERIFY_TOKEN_FAILURE';
export const REFRESH_TOKEN_SUCCESS = 'REFRESH_TOKEN_SUCCESS';
export const REFRESH_TOKEN_FAILURE = 'REFRESH_TOKEN_FAILURE';
export const SET_AUTH_ERROR = 'SET_AUTH_ERROR';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE';
export const RESTORE_AUTH_FROM_STORAGE = 'RESTORE_AUTH_FROM_STORAGE';
export const RESTORE_AUTH_SUCCESS = 'RESTORE_AUTH_SUCCESS';
export const RESTORE_AUTH_FAILURE = 'RESTORE_AUTH_FAILURE';

export type EmailSignInPayload = {
  email: string;
  password: string;
  retry: number;
};

export type GoogleSignInPayload = {
  retry: number;
};

export type EmailSignUpPayload = {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  confirmPassword: string;
  nationality: string | undefined;
  dateOfBirth: string | undefined;
  gender: string | undefined;
  retry: number;
};

export type VerifyTokenPayload = {
  token: string;
  retry: number;
};

export type ChangePasswordPayload = {
  oldPassword: string;
  newPassword: string;
  token: string;
  retry: number;
};

export interface GoogleSignIn extends Action<GoogleSignInPayload> {
  type: typeof GOOGLE_SIGN_IN;
  payload: GoogleSignInPayload;
}

export interface EmailSignIn extends Action<EmailSignInPayload> {
  type: typeof EMAIL_SIGN_IN;
  payload: EmailSignInPayload;
}

export interface SignInSuccess extends Action<{ token: string }> {
  type: typeof SIGN_IN_SUCCESS;
  payload: { token: string };
}

export interface SignInFailure extends Action<string> {
  type: typeof SIGN_IN_FAILURE;
  payload: string;
}

export interface EmailSignUp extends Action<EmailSignUpPayload> {
  type: typeof EMAIL_SIGN_UP;
  payload: EmailSignUpPayload;
}

export interface SignUpFailure extends Action<string> {
  type: typeof SIGN_UP_FAILURE;
  payload: string;
}

export interface SignOut extends Action<void> {
  type: typeof SIGN_OUT;
}

export interface SignOutSuccess extends Action<void> {
  type: typeof SIGN_OUT_SUCCESS;
}

export interface SignOutFailure extends Action<string> {
  type: typeof SIGN_OUT_FAILURE;
}

export interface VerifyToken extends Action<VerifyTokenPayload> {
  type: typeof VERIFY_TOKEN;
  payload: VerifyTokenPayload;
}

export interface VerifyTokenSuccess extends Action<void> {
  type: typeof VERIFY_TOKEN_SUCCESS;
}

export interface VerifyTokenFailure extends Action<string> {
  type: typeof VERIFY_TOKEN_FAILURE;
  payload: string;
}

export interface RefreshTokenSuccess extends Action<string> {
  type: typeof REFRESH_TOKEN_SUCCESS;
  payload: string;
}

export interface RefreshTokenFailure extends Action<string> {
  type: typeof REFRESH_TOKEN_FAILURE;
  payload: string;
}

export interface SetAuthError extends Action<string> {
  type: typeof SET_AUTH_ERROR;
  payload: string;
}

export interface ChangePassword extends Action<ChangePasswordPayload> {
  type: typeof CHANGE_PASSWORD;
  payload: ChangePasswordPayload;
}

export interface ChangePasswordSuccess extends Action<string> {
  type: typeof CHANGE_PASSWORD_SUCCESS;
  payload: string;
}

export interface ChangePasswordFailure extends Action<string> {
  type: typeof CHANGE_PASSWORD_FAILURE;
  payload: string;
}

export interface RestoreAuthFromStorage extends Action<void> {
  type: typeof RESTORE_AUTH_FROM_STORAGE;
  payload: void;
}

export interface RestoreAuthSuccess extends Action<{ token: string }> {
  type: typeof RESTORE_AUTH_SUCCESS;
  payload: { token: string };
}

export interface RestoreAuthFailure extends Action<string> {
  type: typeof RESTORE_AUTH_FAILURE;
  payload: string;
}
